<div class="faux-input-button" (click)="onClickHandler($event)">
    <div class="faux-input-button-content">
        <fcp-icon *ngIf="icon" [icon]="icon.icon"></fcp-icon>
        {{ text }}
    </div>
    <fcp-badge
        *ngIf="badge"
        [color]="badge.color"
        size="small"
        [text]="badge.text | uppercase"
        class="faux-input-button-badge"
    ></fcp-badge>
</div>
